(() => {
  if (customElements.get('omega3-reviews-carousel')) return;

  class Omega3ReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.init = this.init.bind(this);
    }

    connectedCallback() {
      if (typeof Swiper === 'function') {
        this.init();
      } else {
        window.addEventListener('load', this.init, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.init);
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    init() {
      if (this.swiper || typeof Swiper !== 'function') return;

      const el = this.querySelector('.swiper');
      if (!el) return;

      // Mobile: always a swiper. Desktop: keep the swiper only when there are
      // more than 3 reviews; with 3 or fewer, disable it so the cards fall back
      // to a CSS grid that fits the row without clipping.
      const count = this.querySelectorAll('.swiper-slide').length;
      const desktop =
        count > 3
          ? { slidesPerView: 3, slidesOffsetBefore: 0, slidesOffsetAfter: 0 }
          : { enabled: false };

      const spaceBetween = Number(this.dataset.spaceBetween) || 16;

      this.swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween,
        grabCursor: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        breakpoints: {
          1024: desktop,
        },
        navigation: {
          nextEl: this.querySelector('[data-omega3-reviews-next]'),
          prevEl: this.querySelector('[data-omega3-reviews-prev]'),
        },
      });
    }
  }

  customElements.define('omega3-reviews-carousel', Omega3ReviewsCarousel);
})();
